import React, { useState } from "react";
import { FaWhatsapp, FaPhoneAlt, FaMapMarkerAlt, FaFilePdf, FaGlobe } from "react-icons/fa";

const destinations = [
  { name: "Jumeirah College", time: "5 min" },
  { name: "Safa British School", time: "6 min" },
  { name: "Raffles International Dubai", time: "15 min" },
  { name: "Dubai College", time: "17 min" },
  { name: "Emirates Hospital", time: "6 min" },
  { name: "Medcare Hospital", time: "9 min" },
  { name: "Jumeirah Open Beach", time: "5 min" },
  { name: "Kite Beach", time: "7 min" },
  { name: "Al Safa Park", time: "4 min" },
  { name: "Dubai Airport", time: "15 min" },
  { name: "Downtown Dubai", time: "10 min" },
  { name: "Dubai Mall", time: "12 min" },
  { name: "Mall of the Emirates", time: "7 min" },
  { name: "City Walk", time: "7 min" },
];

export default function SahabaVillas({ data }) {
  const [activeLayout, setActiveLayout] = useState("Ground");

  const handleBrochureClick = () => {
    // Send analytics event if window.dataLayer exists
    if (window.dataLayer) {
      window.dataLayer.push({ event: "property_brochure_click", property: "villa" });
    }
    window.open(data.brochurePdf, "_blank");
  };

  const handleWhatsappClick = () => {
    if (window.dataLayer) {
      window.dataLayer.push({ event: "property_whatsapp_click", property: "villa" });
    }
    const message = encodeURIComponent("Hello Al Ghaith Properties, I am interested in Sahaba Villas. I scanned the QR code from your advertisement and would like more information.");
    window.open(`https://wa.me/${data.whatsapp}?text=${message}`, "_blank");
  };

  const handlePhoneClick = () => {
    if (window.dataLayer) {
      window.dataLayer.push({ event: "property_phone_click", property: "villa" });
    }
    window.location.href = `tel:${data.phone}`;
  };

  const handleMapsClick = () => {
    if (window.dataLayer) {
      window.dataLayer.push({ event: "property_maps_click", property: "villa" });
    }
    window.open(data.googleMapsUrl, "_blank");
  };

  const handleWebsiteClick = () => {
    if (window.dataLayer) {
      window.dataLayer.push({ event: "property_website_click", property: "villa" });
    }
    window.open("https://www.al-ghaith.ae", "_blank");
  };

  React.useEffect(() => {
    if (window.dataLayer) {
      window.dataLayer.push({ event: "property_page_view", property: "villa" });
    }
  }, []);

  return (
    <div className="w-full bg-[#f8f9fa] text-gray-800 font-sans overflow-x-hidden">
      
      {/* 1. HERO SECTION */}
      <section className="relative w-full h-[90vh] min-h-[600px] flex items-center justify-center">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${data.heroImage})` }}
        />
        <div className="absolute inset-0 bg-black/40" />
        <div className="relative z-10 text-center px-6 max-w-4xl mx-auto flex flex-col items-center">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-light text-white mb-4 tracking-wider uppercase">
            {data.name}
          </h1>
          <div className="w-24 h-[1px] bg-white/60 mb-6" />
          <p className="text-lg md:text-2xl text-white/90 tracking-widest font-light mb-10 max-w-2xl leading-relaxed uppercase">
            Where Exceptional Living Comes Together
          </p>
          <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
            <button 
              onClick={handleBrochureClick}
              className="bg-white text-black px-8 py-4 rounded-sm text-sm tracking-widest font-semibold hover:bg-gray-200 transition-colors w-full sm:w-auto"
            >
              VIEW FULL BROCHURE
            </button>
            <button 
              onClick={() => document.getElementById("contact-section").scrollIntoView({ behavior: "smooth" })}
              className="border border-white text-white px-8 py-4 rounded-sm text-sm tracking-widest font-semibold hover:bg-white/10 transition-colors w-full sm:w-auto"
            >
              CONTACT US
            </button>
          </div>
        </div>
      </section>

      {/* 2. INTRODUCTION */}
      <section className="py-24 px-6 bg-white text-center">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-light tracking-[0.2em] mb-8 text-[#1a1a1a]">
            SAHABA — MORE THAN A NAME
          </h2>
          <p className="text-lg md:text-xl text-gray-600 font-light leading-relaxed">
            {data.description}
          </p>
        </div>
      </section>

      {/* 3. LIFESTYLE SECTION */}
      <section className="py-24 px-6 bg-[#f0f2f5]">
        <div className="max-w-5xl mx-auto flex flex-col lg:flex-row items-center gap-12">
          <div className="lg:w-1/2">
            <img src={data.gallery[0] || data.heroImage} alt="Lifestyle" className="w-full h-[500px] object-cover rounded-sm shadow-xl" />
          </div>
          <div className="lg:w-1/2 text-center lg:text-left">
            <h2 className="text-3xl md:text-4xl font-light tracking-wide mb-6 text-[#1a1a1a] uppercase leading-tight">
              A Living Experience<br/>Beyond Expectations
            </h2>
            <p className="text-gray-600 leading-relaxed font-light text-lg">
              Exceptional luxury, serenity, spaciousness, and privacy seamlessly integrated to elevate your everyday life.
            </p>
          </div>
        </div>
      </section>

      {/* 4. LOCATION / PROXIMITY */}
      <section className="py-24 px-6 bg-white">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-2xl md:text-3xl font-light tracking-[0.1em] text-[#1a1a1a] mb-6 uppercase">
              Where Dubai's Finest Destinations<br className="hidden md:block" /> Are Just Moments Away
            </h2>
            <button 
              onClick={handleMapsClick}
              className="inline-flex items-center gap-2 text-sm tracking-widest font-semibold text-[#cfa872] hover:text-[#b89565] transition-colors uppercase pb-1 border-b border-[#cfa872]"
            >
              <FaMapMarkerAlt /> View Location
            </button>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
            {destinations.map((dest, idx) => (
              <div key={idx} className="bg-[#f8f9fa] p-6 rounded-sm text-center border border-gray-100 hover:border-[#cfa872] transition-colors">
                <div className="text-2xl font-light text-[#1a1a1a] mb-2">{dest.time}</div>
                <div className="text-sm tracking-wide text-gray-500 uppercase">{dest.name}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 5. INTELLIGENT LAYOUTS */}
      <section className="py-24 px-6 bg-[#1a1a1a] text-white">
        <div className="max-w-5xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-light tracking-[0.1em] mb-12 uppercase">
            Intelligent Layouts Crafted<br className="hidden md:block"/> To Elevate Your Lifestyle
          </h2>
          
          <div className="flex flex-col sm:flex-row justify-center gap-2 sm:gap-4 mb-10">
            {["Ground", "First", "Roof"].map((floor) => (
              <button
                key={floor}
                onClick={() => setActiveLayout(floor)}
                className={`px-6 py-3 text-sm tracking-widest uppercase transition-all border-b-2 ${
                  activeLayout === floor 
                    ? "border-[#cfa872] text-[#cfa872]" 
                    : "border-transparent text-gray-400 hover:text-white"
                }`}
              >
                {floor} Floor Layout
              </button>
            ))}
          </div>

          <div className="bg-white/5 rounded-sm p-4 sm:p-12 min-h-[400px] flex items-center justify-center border border-white/10">
            {data.layouts && data.layouts[activeLayout] ? (
              <img 
                src={data.layouts[activeLayout]} 
                alt={`${activeLayout} Floor Plan`} 
                className="w-full max-w-2xl h-auto object-contain rounded-sm"
              />
            ) : (
              <div className="text-center">
                <FaFilePdf className="mx-auto text-6xl text-white/20 mb-4" />
                <p className="text-lg font-light text-white/70 tracking-widest uppercase">
                  {activeLayout} Floor Plan
                </p>
                <p className="text-sm text-white/40 mt-2 font-light">Refer to brochure for precise architectural drawings</p>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* 6. EXCEPTIONAL DESIGNS */}
      <section className="py-24 px-6 bg-white">
        <div className="max-w-6xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-light tracking-[0.15em] mb-16 text-[#1a1a1a] uppercase">
            Exceptional Designs And Spaces<br className="hidden md:block" /> Tailored To Your Aspiration
          </h2>
          <div className="grid md:grid-cols-2 gap-8">
            <img src={data.gallery[1] || data.heroImage} alt="Exceptional Design" className="w-full h-[400px] object-cover rounded-sm" />
            <img src={data.gallery[2] || data.heroImage} alt="Spacious Layout" className="w-full h-[400px] object-cover rounded-sm" />
          </div>
        </div>
      </section>

      {/* 7 & 8. TRANQUILITY & PRIVACY (Side by side on desktop) */}
      <section className="bg-[#f8f9fa]">
        <div className="grid md:grid-cols-2 h-auto md:h-[600px]">
          <div className="relative group overflow-hidden">
            <img src={data.gallery[3] || data.gallery[0] || data.heroImage} alt="Tranquility" className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105" />
            <div className="absolute inset-0 bg-black/30 flex items-center justify-center p-6 text-center">
              <h2 className="text-2xl md:text-4xl font-light tracking-[0.2em] text-white uppercase">
                Where Tranquility<br/>Meets Spaciousness
              </h2>
            </div>
          </div>
          <div className="relative group overflow-hidden h-[400px] md:h-full">
            <img src={data.gallery[4] || data.gallery[1] || data.heroImage} alt="Privacy" className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105" />
            <div className="absolute inset-0 bg-black/40 flex items-center justify-center p-6 text-center">
              <h2 className="text-2xl md:text-4xl font-light tracking-[0.2em] text-white uppercase">
                Where Privacy<br/>Meets Luxury
              </h2>
            </div>
          </div>
        </div>
      </section>

      {/* 9. DUAL PERSPECTIVES */}
      <section className="py-24 px-6 bg-[#1a1a1a] text-center">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-light tracking-[0.2em] text-white mb-6 uppercase">
            Dual Perspectives
          </h2>
          <p className="text-xl md:text-2xl text-[#cfa872] font-light tracking-widest uppercase mb-12">
            Serene Avenue & Vibrant Boulevard
          </p>
          <img src={data.gallery[5] || data.gallery[2] || data.heroImage} alt="Dual Perspectives" className="w-full h-[500px] object-cover rounded-sm opacity-80" />
        </div>
      </section>

      {/* 10. BROCHURE CTA */}
      <section className="py-24 px-6 bg-white text-center border-b border-gray-200">
        <div className="max-w-2xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-light tracking-[0.1em] text-[#1a1a1a] mb-6 uppercase">
            Explore Sahaba Villas
          </h2>
          <p className="text-gray-600 mb-10 text-lg font-light">
            Discover the complete vision, layouts and details.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <button 
              onClick={handleBrochureClick}
              className="bg-[#1a1a1a] text-white px-8 py-4 rounded-sm text-sm tracking-widest font-semibold hover:bg-black transition-colors"
            >
              VIEW FULL BROCHURE
            </button>
            <button 
              onClick={() => document.getElementById("contact-section").scrollIntoView({ behavior: "smooth" })}
              className="border border-[#1a1a1a] text-[#1a1a1a] px-8 py-4 rounded-sm text-sm tracking-widest font-semibold hover:bg-gray-50 transition-colors"
            >
              CONTACT AL GHAITH PROPERTIES
            </button>
          </div>
        </div>
      </section>

      {/* 11. CONTACT SECTION */}
      <section id="contact-section" className="py-24 px-6 bg-[#f8f9fa] text-center pb-32 md:pb-24">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-light tracking-widest text-[#1a1a1a] mb-12 uppercase">
            Get In Touch
          </h2>
          <div className="grid sm:grid-cols-3 gap-6">
            <button onClick={handlePhoneClick} className="flex flex-col items-center justify-center p-8 bg-white border border-gray-100 hover:border-[#cfa872] transition-colors rounded-sm group">
              <div className="w-12 h-12 bg-gray-50 flex items-center justify-center rounded-full mb-4 group-hover:bg-[#cfa872]/10 text-gray-400 group-hover:text-[#cfa872] transition-colors">
                <FaPhoneAlt size={20} />
              </div>
              <span className="text-sm font-semibold tracking-widest uppercase">Call Us</span>
            </button>
            
            <button onClick={handleWhatsappClick} className="flex flex-col items-center justify-center p-8 bg-white border border-gray-100 hover:border-[#25D366] transition-colors rounded-sm group">
              <div className="w-12 h-12 bg-gray-50 flex items-center justify-center rounded-full mb-4 group-hover:bg-[#25D366]/10 text-gray-400 group-hover:text-[#25D366] transition-colors">
                <FaWhatsapp size={24} />
              </div>
              <span className="text-sm font-semibold tracking-widest uppercase">WhatsApp Us</span>
            </button>

            <button onClick={handleWebsiteClick} className="flex flex-col items-center justify-center p-8 bg-white border border-gray-100 hover:border-blue-500 transition-colors rounded-sm group">
              <div className="w-12 h-12 bg-gray-50 flex items-center justify-center rounded-full mb-4 group-hover:bg-blue-50 text-gray-400 group-hover:text-blue-500 transition-colors">
                <FaGlobe size={20} />
              </div>
              <span className="text-sm font-semibold tracking-widest uppercase">Visit Website</span>
            </button>
          </div>
        </div>
      </section>

      {/* 12. MOBILE STICKY BAR */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-[0_-4px_10px_rgba(0,0,0,0.05)] z-50 flex">
        <button 
          onClick={handleWhatsappClick}
          className="flex-1 flex items-center justify-center gap-2 py-4 text-sm font-semibold text-[#25D366] border-r border-gray-200 hover:bg-gray-50"
        >
          <FaWhatsapp size={20} />
          WHATSAPP
        </button>
        <button 
          onClick={handlePhoneClick}
          className="flex-1 flex items-center justify-center gap-2 py-4 text-sm font-semibold text-[#1a1a1a] hover:bg-gray-50"
        >
          <FaPhoneAlt size={16} />
          CALL
        </button>
      </div>

    </div>
  );
}
